'use client';
import Page from '@/pages/Jobs';
export default Page;